import { render, staticRenderFns } from "./StageParticipants.vue?vue&type=template&id=5da2c34f&"
import script from "./StageParticipants.vue?vue&type=script&lang=js&"
export * from "./StageParticipants.vue?vue&type=script&lang=js&"
import style0 from "./StageParticipants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports